const ZENDESK = 'zendesk';
const ZENDESK_EMAIL_PUSH = 'zendesk_email_push';
const DESK = 'desk';
const SENDBOTTLES = 'sendbottles';
const INTERCOM = 'intercom';
const MESSENGER = 'messenger';
const GMAIL = 'gmail';
const GORGIAS = 'gorgias';
const ZENDESK_CHAT = 'zendesk_chat';
const SALESFORCE = 'salesforce';
const SALESFORCE_CHAT = 'salesforce_chat';
const SALESFORCE_CHAT_2 = 'salesforce_chat_2';
const GLADLY = 'gladly';
const GENESYS = 'genesys';
const SIMPLR_CHAT = 'simplr_chat';
const AMAZON_CONNECT = 'amazon_connect';

export const ESCALATABLE_CONVERSATION_TYPES = [
  ZENDESK,
  ZENDESK_EMAIL_PUSH,
  DESK,
  SENDBOTTLES,
  INTERCOM,
  MESSENGER,
  GMAIL,
  GORGIAS,
  ZENDESK_CHAT,
  SALESFORCE,
  SALESFORCE_CHAT,
  SALESFORCE_CHAT_2,
  GLADLY,
  GENESYS,
  SIMPLR_CHAT,
  AMAZON_CONNECT,
];

export const MESSAGE_TYPES_WITH_STANDARD_PLATFORM_DATA_STORAGE_FORMAT = [
  SENDBOTTLES,
  INTERCOM,
  MESSENGER,
  GMAIL,
  GORGIAS,
  DESK,
  ZENDESK,
  ZENDESK_CHAT,
  SALESFORCE,
  SALESFORCE_CHAT,
  SALESFORCE_CHAT_2,
  GLADLY,
  GENESYS,
  AMAZON_CONNECT,
];

const SIMPLR_ORDER = 'simplrOrder';
const COMMON = 'common';

export const SUBSCRIPTION_SYSTEMS = {
  SIMPLR_ORDER: SIMPLR_ORDER,
  COMMON: COMMON,
};
